/**
 * 投稿フォームネタバレチェックボックスオンオフコンポーネント
 */
export default class PostFormSpoilerEnabler {
  /**
   * Public: コンストラクタ
   *
   * options - 以下のようなプロパティを持つオブジェクト。
   *           el               - 投稿フォーム要素のElement。
   *           textareaSelector - 本文用テキストエリアのセレクタ。
   *           checkboxSelector - ネタバレチェックボックスのセレクタ。
   */
  constructor(options) {
    this.options = options;
    const form = this.options.el;
    this.textarea = form.querySelector(this.options.textareaSelector);
    this.checkbox = form.querySelector(this.options.checkboxSelector);
  }

  init() {
    this.bindEvents();
    this.initSpoilerCheckbox();
  }

  /**
   * Internal: イベントハンドラを設定します。
   */
  bindEvents() {
    this.textarea.addEventListener(
      "keyup",
      this.generateEventHandlerFunction(),
    );
  }

  initSpoilerCheckbox() {
    if (this.textarea.value === "") {
      this.disableCheckbox();
    }
  }

  disableCheckbox() {
    // チェックボックスのチェックを外して要素を無効化する
    this.checkbox.checked = false;
    this.checkbox.disabled = true;
  }

  enableCheckbox() {
    this.checkbox.disabled = false;
  }

  /**
   * テキストエリアの値が変更になったかどうか判定する関数を生成して返す
   */
  generateEventHandlerFunction() {
    let { value } = this.textarea;
    let oldValue = this.textarea.value;
    return () => {
      value = this.textarea.value; // eslint-disable-line prefer-destructuring
      if (value === oldValue) {
        // 値が変更されていなければ何もしない
        return;
      }
      if (value === "") {
        // 値が空文字列になった場合はチェックボックスを無効化する
        this.disableCheckbox();
      } else if (oldValue === "") {
        // 変更前の値が空文字列だった場合はチェックボックスを有効化する
        this.enableCheckbox();
      }
      oldValue = value;
    };
  }
}
